import { Alert, Card } from "react-bootstrap";
import i18n from "i18next";
import { ResolvedDocumentAttachment } from "../../services/document/DocumentAttachmentService";
import { PapyrusDocumentRepresentation } from "../../services/document/DocumentModels";

type ImageViewerProps = {
    representation: PapyrusDocumentRepresentation;
    resolvedAttachment?: ResolvedDocumentAttachment;
};

export default function ImageViewer({ representation, resolvedAttachment }: ImageViewerProps) {
    const imageUrl = resolvedAttachment?.sourceUrl ?? resolvedAttachment?.objectUrl;

    return (
        <Card>
            <Card.Body>
                <Card.Title>{i18n.t("viewer.image")}</Card.Title>
                <Card.Subtitle className="mb-2 text-muted">
                    {representation.contentType}
                </Card.Subtitle>
                {imageUrl ? (
                    <div className="text-center overflow-auto">
                        <img
                            alt={representation.id}
                            src={imageUrl}
                            style={{ maxWidth: "100%", maxHeight: "80vh" }}
                        />
                    </div>
                ) : (
                    <Alert variant="warning">{i18n.t("viewer.noimage")}</Alert>
                )}
            </Card.Body>
        </Card>
    );
}
